import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  Cnpj,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { tableCellCentered } from '../../../../assets/js/styles'
import * as SeguradoraHttp from '../../../../services/api/https/registration/seguradora.http'
import SeguradoraModal from './SeguradoraModal'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  INIT: 'Adquirindo informações iniciais',
  SAVE: 'Salvando seguradora',
  SUCCESS: 'Seguradora salvo com sucesso',
}

const INITIAL_STATE = {
  seguradoras: [],
  modal: { show: false, data: null },
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

const Seguradora = ({ history, dispatch, selectedTp }) => {
  const [state, setState] = useState({ ...INITIAL_STATE })

  // Events
  const onBtnNovo = selectedTp => {
    if (selectedTp) setState(prevState => ({ ...prevState, modal: { show: true, data: null } }))
    else setState(prevState => ({ ...prevState, errorMessage: 'Selecione um operador logístico' }))
  }

  const onModalClose = () => {
    setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
  }

  const onModalSave = async seguradora => {
    setState(prevState => {
      const index = prevState.seguradoras.findIndex(v => v.id === seguradora.id)
      if (index !== -1) {
        prevState.seguradoras[index] = seguradora
      } else {
        prevState.seguradoras.unshift(seguradora)
      }
      return { ...prevState, modal: { show: false, data: null } }
    })
  }

  const onMenuItemClick = (menuItem, seguradora) => {
    if (menuItem === 'Editar') {
      setState(prevState => ({ ...prevState, modal: { show: true, data: seguradora } }))
    }
  }

  const onChangeGlobalFilter = value => {
    setState(prevState => ({ ...prevState, globalFilter: value }))
  }

  // Helpers
  const getSeguradoras = selectedTp => {
    if (selectedTp === 0) setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
    else
      SeguradoraHttp.getSeguradoras(selectedTp)
        .then(fetchedSeguradoras =>
          setState(prevState => ({
            ...prevState,
            seguradoras: fetchedSeguradoras,
            loadingMessage: LOAD_MESSAGE.NONE,
          })),
        )
        .catch(err =>
          setState(prevState => ({
            ...prevState,
            errorMessage: errorHandler(err),
            loadingMessage: LOAD_MESSAGE.NONE,
          })),
        )
  }

  const initialFetch = () => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.INIT }))
  }

  // Hooks
  useEffect(() => {
    initialFetch()
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.INIT:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        getSeguradoras(selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>2.14 - Cadastro de Seguradoras</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => onBtnNovo(selectedTp)} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              <DataTable
                value={state.seguradoras}
                header={<CustomDataTableHeader onChange={value => onChangeGlobalFilter(value)} />}
                emptyMessage={'Não existe seguradoras cadastradas . . .'}
                globalFilter={state.globalFilter}
                paginator={true}
                rows={10}
              >
                <Column field="id" header="Código" style={tableCellCentered(80)} />
                <Column
                  field="cnpj"
                  header="CNPJ"
                  style={tableCellCentered(300)}
                  body={item => <Cnpj>{item.cnpj}</Cnpj>}
                />
                <Column field="razao_social" header="Razão Social" />
                <Column
                  field="actived"
                  header="Ativo"
                  style={tableCellCentered(80)}
                  body={seguradora => (
                    <CustomCheckbox onChange={() => {}} checked={seguradora.actived} />
                  )}
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(80)}
                  body={seguradora => (
                    <ThreeDots
                      items={['Editar']}
                      onClick={menuItem => onMenuItemClick(menuItem, seguradora)}
                    />
                  )}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <SeguradoraModal
        show={state.modal.show}
        onModalClose={onModalClose}
        onModalSave={onModalSave}
        data={state.modal.data}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(Seguradora))
